import _BaseController from 'Controllers/Web/_BaseController';
import ListController from 'Vue/Web/Common/Note/ListController.vue';

global.Controller = new (class extends _BaseController {
    ListControllerVue?: Vue;

    ready() {
        super.ready();

        /* 初始vue */
        this.ListControllerVue = new Vue({
            ...ListController,
            el: '.noteContent',
            propsData: {
                authCheck: Json.authCheck,
            },
        });
    }
})();
